export default {
  send: 'Send',
};
